import { createSlice } from "@reduxjs/toolkit";

export const userSlice = createSlice({
  name: "users",
  initialState: {
    userId: "",
    username: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    gender: "",
    userRole: "",
    address1: "",
    stores: [],
    role: null,
    selectedStoreId: 0,
    maxDiscount: 0,
    myTeam: "",
    approvalRequirementFor: 0,
    userPassword: "",
    confirmPassword: ""
  },
  reducers: {
    addUser: (state, action) => {
      const {
        userId,
        username,
        firstName,
        lastName,
        email,
        gender,
        phone,
        maxDiscount,
        myTeam,
        approvalRequirementFor,
        userPassword,
        confirmPassword,
        stores,
        role,
      } = action.payload;

      return {
        ...state,
        userId,
        username,
        firstName,
        lastName,
        email,
        phone,
        gender,
        maxDiscount,
        myTeam,
        approvalRequirementFor,
        userPassword,
        confirmPassword,
        stores,
        selectedStoreId: stores?.[0]?.storeId || 0,
        userRole: role?.roleName || "",
        role,
      };
    },

    // Reset user state on logout
    logoutUser: (state) => {
      return {
        ...state,
        userId: 0,
        username: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        gender: "",
        userRole: "",
        address1: "",
        stores: [],
        selectedStoreId: 0,
        maxDiscount: 0,
        myTeam: "",
        approvalRequirementFor: 0,
        userPassword: "",
        confirmPassword: ""
      };
    },

    // Select a store and update the selectedStoreId
    selectStore: (state, action) => {
      return {
        ...state,
        selectedStoreId: action.payload
      };
    },

    // Add stores
    addStore: (state, action) => {
      return {
        ...state,
        stores: action.payload
      };
    }
  },
});

// Export the actions 
export const { addUser, logoutUser, selectStore, addStore } = userSlice.actions;

// Export the reducer 
export default userSlice.reducer;
